import MainTaskTemplate from "../components/task-template/main-template";

function TaskTemplate() {
 

  return (
    <div className="">
      <MainTaskTemplate/>
    </div>
  );
}

export default TaskTemplate;
